import { render, staticRenderFns } from "./Shiplading.vue?vue&type=template&id=6f0b41ec&scoped=true&"
import script from "./Shiplading.vue?vue&type=script&lang=js&"
export * from "./Shiplading.vue?vue&type=script&lang=js&"
import style0 from "./Shiplading.vue?vue&type=style&index=0&id=6f0b41ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b41ec",
  null
  
)

export default component.exports